<template>
  <div>
    <Header title="教学评价"></Header>
    <div class="eva-detail">
        <div class="xspxTop">
        <div id="courseName"></div>
        <div class="teacherName">评学教师：<span id="teacherName"></span></div>
        <div class="score">总评分<span id="score"></span></div>
        <!-- <p>评学教师：{{ cphdmc }}</p>
        <p>评学班级：{{ xnxqmc }} </p> -->
      </div>

      <!-- 选项评价 -->
      <div 
        v-for="(item, index) in radioEvaluate" 
        :key="index"
      >
        <div class="xspjItem">
          <p class="eva-topic">
            {{ item.targetName }}
          </p>
          <div class="eva-rate">
            <ul>
              <div
                v-for="(oItem, option_index) in item.optionData"
                :key="option_index"
              >
                <!-- <keep-alive>  -->
                <div class="eva-rateDesc">
                  <input type="radio"
                    :class="checked"
                    checked
                    v-if="oItem.isCheck =='1'"
                    @click="pickOpt(option_index, index)"
                    :name="item.targetId"
                    :value="option_index"
                  />
                   <input type="radio" 
                    v-else 
                    @click="pickOpt(option_index, index)"
                    :name="item.targetId"
                    :value="option_index"
                  />
                    {{ oItem.optionName }}
                </div>
                  
                  
                <!-- </keep-alive> -->
              </div>
            </ul>
          </div>
        </div>
          
      </div> 
      <!-- 主观评语 -->
       <div 
              v-if="sfyzj =='1'" 
       >
          <div 
                  v-for="(item, index) in pj06zgpyList" 
                  :key="index" 
          >
              <div class="xspjItem">
                <p class="eva-topic">
                  {{ item.zbmc }}
                </p>
              
              <div class="eva-rate">
                <ul>
                  <div
                    v-for="(oItem, option_index) in item.children"
                    :key="option_index"
                  >
                    <!-- <keep-alive>  -->
                    <div class="eva-rateDesc">
                      <input type="checkbox"
                        :class="checked"
                        checked
                        v-if="oItem.ischecked =='1'" 
                        name="zgpyOpt"
                        :value="oItem.zgpyid"
                      />
                      <input type="checkbox" 
                        v-else  
                        name="zgpyOpt"
                        :value="oItem.zgpyid"
                      />
                        {{ oItem.zbmc }}
                    </div>
                      
                      
                    <!-- </keep-alive> -->
                  </div>
                </ul>
              </div>
            </div>
          </div>
       </div>
       <div 
             v-else
       >
          <div >
            <div class="xspjItem">
                <p class="eva-topic">
                 主观评语
                </p>
              
              <div class="eva-rate">
                <ul>
                  <div
                    v-for="(oItem, option_index) in pj06zgpyList"
                    :key="option_index"
                  >
                    <!-- <keep-alive>  -->
                    <div class="eva-rateDesc">
                      <input type="checkbox" 
                        checked
                        v-if="oItem.ischecked =='1'" 
                        name="zgpyOpt"
                        :value="oItem.zgpyid"
                      />
                      <input type="checkbox" 
                        v-else  
                        name="zgpyOpt"
                        :value="oItem.zgpyid"
                      />
                        {{ oItem.zbmc }}
                    </div> 
                    <!-- </keep-alive> -->
                  </div>
                </ul>
              </div>
            </div>
          </div>
       </div>

      <!-- 建议textarea评价 -->
      <template >
        <div 
          v-for="(item, index) in textEvaluate" 
          :key="item.suggestTypeId"
        >
          <div class="pjjyItem">
            <p class="eva-topic" >
              {{ item.suggestTypeName }}
            </p>
            <div class="eva-rate">
              <keep-alive>
                <textarea rows="5" cols="35" 
                  name
                  placeholder="请点击填写"
                  v-model="item.suggestContent"
                  @blur="pickText(item, index)"
                  maxlength="140"
                ></textarea>
              </keep-alive>
              <!-- <span>{{ calcNum() }}</span> -->
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="eva-buttons" v-if="this.isSubmitCode != '1'">
      <input type="button"
        class="pre-topic btnLfte"
        @click="preTopic()"
        value="取消"
      >
      <input type="button"
        class="eva-btn btnRight"
        @click="saveEvaTap()"
        value="提交"
      >
    </div>
  </div>
</template>

<script>
import evaluateVue from "./evaluate.vue";
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      schoolCode: "",
      evaluateIndex: 0,
      evaluateList: [],
      textEvaluate: [],
      radioEvaluate: [],
      evaText: "",
      total: "",
      optionList: [],
      pickOptVal: [],
      pickZgpyOptVal: new Set(),
      textVal: [],
      isCheck: null,
      textIndex: "",
      maxNum: "140",
      overtimer: null,
      sfyzj:"",
      pj06zgpyList:[],
      pj06zgpyList_zj:[],
      courseName:this.$route.query.info1,
      teacherName:this.$route.query.info3,
      score:this.$route.query.score,
      isSubmitCode:this.$route.query.isSubmitCode
    };
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    console.log(this.schoolCode);
    // if (this.$store.state.evaOptCheck[0] != 0) {
    //   this.isCheck = this.$store.state.evaOptCheck[0]
    // } else {
    //   this.isCheck = null;
    // }
    this.getEva();
  },
    mounted(){
      var courseNameSpan = $("#courseName")
      console.log(courseNameSpan)
      console.log(this.courseName)
      courseNameSpan.html(this.courseName)
      var teacherNameSpan = $("#teacherName")
      // console.log(itemNameSpan.html)
      teacherNameSpan.html(this.teacherName)
      var scoreSpan = $("#score") 
      scoreSpan.html(this.score)
      
    },
  methods: {
    async getEva() {
      const params = {
        batchId: this.$route.query.id0,
        evaluationCategoriesId: this.$route.query.id1,
        courseId: this.$route.query.id2,
        teacherId: this.$route.query.id3,
        noticeId: this.$route.query.id4,
        schoolClassificationId: this.$route.query.id5
      };
      const res = await Api.getEvaluationIndex(params);
      this.textEvaluate = res.data.suggestData;
      for (let i = 0; i < res.data.targetData.length; i++) {
        if (res.data.targetData[i].optionData) {
          this.radioEvaluate = this.radioEvaluate.concat(
            res.data.targetData[i]
          );
        }
      }
      this.textIndex = this.radioEvaluate.length;
      this.total = this.textEvaluate.length + this.radioEvaluate.length;
      console.log(this.radioEvaluate)
      this.sfyzj = res.data.sfyzj
      this.pj06zgpyList =  res.data.pj06zgpyList
      this.pj06zgpyList_zj =  res.data.pj06zgpyList_zj
    },
    
    calcNum() {
      this.maxNum = 140 - this.evaText.length;
      return this.maxNum;
    },
    pickOpt(option_index, index) { 
      this.isCheck = index;
      if (this.pickOptVal[index] != null && this.pickOptVal[index] != undefined){
          this.pickOptVal[index].targetid = this.radioEvaluate[index].targetId,
          this.pickOptVal[index].targetval = this.radioEvaluate[index].optionData[option_index].optionId;
      }else {
        this.pickOptVal.push({
          targetid: this.radioEvaluate[index].targetId,
          targetval: this.radioEvaluate[index].optionData[ option_index ].optionId
        });
      }
    },
    pickZgpyOpt(option_index, index) { 
      // this.isCheck = index;
      // if (this.pickZgpyOptVal[index] != null && this.pickZgpyOptVal[index] != undefined){
      //     this.pickZgpyOptVal[index].targetid = this.pj06zgpyList[index].zgpyid,
      //     this.pickZgpyOptVal[index].targetval = this.pj06zgpyList[index].children[ option_index ].zgpyid;
      // }else {
      //   this.pickZgpyOptVal.push({
      //     targetid: this.pj06zgpyList[index].zgpyid,
      //     targetval: this.pj06zgpyList[index].children[ option_index ].zgpyid
      //   });
      // }
      if(999 == option_index){//没有子级指标
        this.pickZgpyOptVal.add(this.pj06zgpyList[index].zgpyid) 
      }else{//有子级指标
        this.pickZgpyOptVal.add(this.pj06zgpyList[index].children[ option_index ].zgpyid) 
      }
      console.log(this.pickZgpyOptVal)
    }, 
    pickText(item, index) {
      // 已存在更新，不存在新增
      if (this.textVal[index] != null && this.textVal[index] != undefined){
        this.textVal[index].suggestid = this.textEvaluate[index].suggestTypeId;
        this.textVal[index].suggestval = item.suggestContent;
      }else {
        this.textVal.push({
          suggestid: this.textEvaluate[index].suggestTypeId,
          suggestval: item.suggestContent
        });
      }
    },
    
    preTopic() {
      if (this.evaluateIndex > 0) {
        this.evaluateIndex--;
        if (this.evaluateIndex >= this.textIndex){
          this.evaText = this.textVal[this.evaluateIndex - this.textIndex].suggestval
        }else {
          this.isCheck = this.$store.state.evaOptCheck[this.evaluateIndex];
        }
      }
    },
    async saveEvaTap() { 
       console.log("obj", {
            evaluationCategoriesId: this.$route.query.id1,
            target: this.pickOptVal,
            batchId: this.$route.query.id0,
            teacherId: this.$route.query.id3,
            noticeId: this.$route.query.id4,
            schoolClassificationId: this.$route.query.id5,
            courseId: this.$route.query.id2, 
            suggest: this.textVal
          }); 
        //查询主观评语 
        var zgpyOpts = document.getElementsByName("zgpyOpt");
        for(var i=0;i<zgpyOpts.length; i++){
            if(zgpyOpts[i].checked){
                 this.pickZgpyOptVal.add(zgpyOpts[i].value) 
            }
        }
        console.log(this.pickZgpyOptVal) 
        if( this.pickOptVal.length < this.radioEvaluate.length){
          this.$toast.fail("请选择指标！");
          return
        }
        if( this.pickZgpyOptVal.length <= 0 ){
          this.$toast.fail("请选择主观评语!");
          return
        }
        if( this.textVal.length < this.textEvaluate.length){
          this.$toast.fail("请填写建议！");
          return
        } 
        let formData = {
        evaluationCategoriesId: this.$route.query.id1,
        target: this.pickOptVal,
        batchId: this.$route.query.id0,
        teacherId: this.$route.query.id3,
        noticeId: this.$route.query.id4,
        schoolClassificationId: this.$route.query.id5,
        courseId: this.$route.query.id2,
        suggest: this.textVal,
        pickZgpyOptVal: this.pickZgpyOptVal
        };
        const data = formData;
        const res = await Api.stuSaveEvaluate(data);
        if (res.code == "success") { 
            this.$toast.success("评教成功~");
            this.$store.state.evaOptCheck = [];
            // this.$router.push('/student/evaluate')
            this.$router.push({
              name: "teachEvaluate_10013",
              query: {
                pj01id: this.$route.query.pj01id,
                pj05id: this.$route.query.pj05id,
                pj0502id: this.$route.query.pj0502id
              }
            });
          
        } else {
          this.$toast(res.errorMessage);
        }
      },
    nextTopic() {
      this.$store.state.evaOptCheck[this.evaluateIndex] = this.isCheck;
      //无主观评价
      if (this.textEvaluate.length == 0) {
        if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
            this.pickOptVal[this.evaluateIndex].targetid = this.radioEvaluate[this.evaluateIndex].targetId,
            this.pickOptVal[this.evaluateIndex].targetval = this.radioEvaluate[this.evaluateIndex].optionData[this.isCheck].optionId;
        }else {
          this.pickOptVal.push({
            targetid: this.radioEvaluate[this.evaluateIndex].targetId,
            targetval: this.radioEvaluate[this.evaluateIndex].optionData[
              this.isCheck
            ].optionId
          });
        }
        if (this.evaluateIndex + 1 < this.total) {
          if (this.isCheck == null) {
            this.$toast.fail("请选择");
          } else {
            this.evaluateIndex += 1;
            if (this.$store.state.evaOptCheck[this.evaluateIndex] != 0) {
              this.isCheck = this.$store.state.evaOptCheck[this.evaluateIndex];
            } else {
              this.isCheck = 0;
            }
          }
        } else {
          let formData = {
            evaluationCategoriesId: this.$route.query.id1,
            target: this.pickOptVal,
            batchId: this.$route.query.id0,
            teacherId: this.$route.query.id3,
            noticeId: this.$route.query.id4,
            schoolClassificationId: this.$route.query.id5,
            courseId: this.$route.query.id2,
            suggest: []
          };
          this.saveEvaTap(formData);
        }
        //有主观评价
      } else {
        if (this.evaluateIndex < this.total - this.textEvaluate.length) {
          if (this.isCheck == null) {
            this.$toast.fail("请选择");
          } else {
            // 这一题已经存在数据则更新
            if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
              this.pickOptVal[this.evaluateIndex].targetid = this.radioEvaluate[this.evaluateIndex].targetId;
              this.pickOptVal[this.evaluateIndex].targetval = this.radioEvaluate[this.evaluateIndex].optionData[this.isCheck].optionId;
            }else {
              this.pickOptVal.push({
                targetid: this.radioEvaluate[this.evaluateIndex].targetId,
                targetval: this.radioEvaluate[this.evaluateIndex].optionData[
                  this.isCheck
                ].optionId
              });
            }
            this.evaluateIndex += 1;
            if (this.$store.state.evaOptCheck[this.evaluateIndex] != 0) {
              this.isCheck = this.$store.state.evaOptCheck[this.evaluateIndex];
            } else {
              this.isCheck = 0;
            }
          }
        } else {
            if (this.evaText == "") {
                this.$toast.fail("请填写!!");
                return false;
            }
            // 已存在更新，不存在新增
            if (this.textVal[this.evaluateIndex - this.textIndex] != null && this.textVal[this.evaluateIndex - this.textIndex] != undefined){
              this.textVal[this.evaluateIndex - this.textIndex].suggestid = this.textEvaluate[this.evaluateIndex - this.textIndex].suggestTypeId;
              this.textVal[this.evaluateIndex - this.textIndex].suggestval = this.evaText;
            }else {
              this.textVal.push({
                suggestid: this.textEvaluate[this.evaluateIndex - this.textIndex].suggestTypeId,
                suggestval: this.evaText // this.$store.state.evaTextList[this.textIndex - this.evaluateIndex]
              });
            }
          this.evaText = "";
          let formData = {
            evaluationCategoriesId: this.$route.query.id1,
            target: this.pickOptVal,
            batchId: this.$route.query.id0,
            teacherId: this.$route.query.id3,
            noticeId: this.$route.query.id4,
            schoolClassificationId: this.$route.query.id5,
            courseId: this.$route.query.id2,
            suggest: this.textVal
          };
          if (this.evaluateIndex + 1 < this.total) {
            this.evaluateIndex += 1;
          } else {
            this.saveEvaTap(formData);
          }
        }
      }
       
      console.log("obj", {
            evaluationCategoriesId: this.$route.query.id1,
            target: this.pickOptVal,
            batchId: this.$route.query.id0,
            teacherId: this.$route.query.id3,
            noticeId: this.$route.query.id4,
            schoolClassificationId: this.$route.query.id5,
            courseId: this.$route.query.id2, 
          });
    }
  },
  beforeDestroy() {
    this.overtimer && clearTimeout(this.overtimer);
    this.overtimer = null;
  }
};
</script>

<style lang="less" scoped>
.eva-detail{
  padding: 10px;
  background-image: url("../../../../static/images_10013/统计背景.png");
  background-color: #2b67e1;
  .xspxTop{
    margin: 12px 15px;
    // background-color: #2b67e1;
    box-shadow: 0 2px 10px 0 #2b67e14d;
    border-radius: 8px;
    height: 46px;
    padding: 5px;
    color: #fff;
    #courseName{
      font-weight: 600;
      font-size: 20px;
      height: 22px;
      padding-bottom: 6px;
    }
    .teacherName{
      font-weight: 400;
      font-size: 14px;
      opacity: 0.8;
      height: 20px;
    }
  }
  .xspjItem{
    margin-bottom: 10px;
    //  width: 100%;
    border-radius: 8px;
    background-color: #fff;
    padding: 16px 15px 16px 24px;
    .eva-topic{
      font-weight: 500;
      font-size: 16px;
      color: #333;
      padding-bottom: 14px;
    }
    .eva-rate{
      padding-left: 10px;
      .eva-rateDesc{
        font-weight: 400;
        font-size: 16px;
        color: #666;
        padding-bottom: 14px;
      }
    }
    
  }
  .pjjyItem{
    margin-bottom: 10px;
    // width: 100%;
    border-radius: 8px;
    background-color: #fff;
    padding: 16px 15px 16px 24px;
    .eva-topic{
      font-weight: 500;
      font-size: 16px;
      color: #333;
      padding-bottom: 14px;
    }
    .eva-rate{
      width: 325px;
      border-radius: 4px;
      padding: 0px 12px;
      textarea{
        font-size: 14px;
        font-weight: 400;
        color: #333;
        border: 0.5px solid #e5e5e5;
        padding: 15px;
      }
    }
  }
}
.eva-buttons{
  background-color: #fff;
  padding: 10px 15px;
  margin: 0px -10px;
  // height: 50px;
  input{
    font-weight: 500;
    font-size: 18px;
    width: 45%;
    height: 50px;
    text-align: center;
    border: 1px solid #e5e5e5;
    border-radius: 25px;
  }
  .btnLfte{
    margin-left: 10px;
  }
  .btnRight{
    color:#fff;
    background-color: #2b67e1;
  }
}


// .eva-detail {
//   padding: 0 20px;
//   margin-bottom: 20px;
// }
// .eva-detail .eva-num {
//   color: @attendance-background-color-2;
//   font-size: 18px;
// }
// .eva-detail .eva-num span {
//   color: @attendance-background-color-1;
//   font-size: 48px;
//   font-weight: 600;
// }
// .eva-detail .eva-topic {
//   color: @attendance-color-2;
//   font-size: 18px;
//   font-weight: 600;
//   line-height: 25px;
// }
// .eva-detail .eva-rate {
//   margin-top: 20px;
// }
// .eva-detail .eva-rate ul li {
//   padding: 20px;
//   font-weight: 600;
//   border-radius: 5px;
//   margin-bottom: 20px;
//   background-color: @attendance-background-color-10;
//   color: @attendance-color-1;
// }
// .eva-detail .eva-rate ul li.checked {
//   padding: 20px;
//   font-weight: 600;
//   border-radius: 5px;
//   margin-bottom: 20px;
//   background-color: @attendance-background-color-12;
//   color: @attendance-color-3;
// }
// .eva-detail .eva-rate textarea {
//   width: 100%;
//   padding: 20px;
//   background-color: @attendance-background-color-6;
//   border-radius: 3px;
//   box-sizing: border-box;
//   color: @attendance-color-1;
//   height: 350px;
// }
// .eva-detail .eva-rate textarea::placeholder {
//   color: @attendance-color-2;
// }
// .eva-detail .eva-rate {
//   position: relative;
// }
// .eva-detail .eva-rate span {
//   color: @attendance-color-2;
//   position: absolute;
//   bottom: 20px;
//   right: 20px;
// }
// .eva-buttons {
//   position: relative;
//   bottom: 0px;
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   padding: 0 20px;
//   box-sizing: border-box;
//   padding: 20px;
//   background-color: @attendance-color-3;
// }
// .eva-buttons button {
//   border-radius: 3px;
//   padding: 11px 0;
//   width: calc(~"50% - 10px");
// }
// .eva-buttons .eva-btn {
//   background-color: @attendance-background-color-1;
//   color: @attendance-color-3;
// }
// .eva-buttons .pre-topic {
//   background-color: @attendance-background-color-6;
//   color: @attendance-background-color-1;
// }
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/detailEvaluate_10013.vue